import { Component, input, output } from '@angular/core';

@Component({
  selector: 'eiq-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.scss', '_selectable-card-theme.component.scss']
})
export class SelectableCardComponent {
  isSelected$ = input<boolean>(false);
  clickable$ = input<boolean>(false);
  testId$ = input<string>();

  clicked = output<void>();
}
